import QuickLinksColumns from "@/components/pages/Community/QuickLinksColumns/QuickLinksColumns";

export default QuickLinksColumns;
